import * as Sentry from '@sentry/react';
import { setupStatusStyling } from './utils/status-styler';
import type { StrapiApp } from '@strapi/strapi/admin';

/**
 * Injectés au build par `vite.config.ts` : sur Strapi Cloud les variables
 * `STRAPI_ADMIN_*` ne sont pas exposées au front admin, le seul canal fiable
 * est donc le `define` de Vite.
 */
declare const SENTRY_DSN_INJECTED: string;
declare const SENTRY_ENVIRONMENT_INJECTED: string;

if (SENTRY_DSN_INJECTED) {
  Sentry.init({
    dsn: SENTRY_DSN_INJECTED,
    environment: SENTRY_ENVIRONMENT_INJECTED,
    // Le BO est un outil interne à faible trafic : on veut les erreurs, pas des
    // traces de performance. Les erreurs sont donc prises à 100 %.
    tracesSampleRate: 0,
    // Même projet Sentry que le serveur : ce tag sépare les deux runtimes.
    initialScope: { tags: { runtime: 'admin' } },
  });
}

/**
 * Custom Strapi Admin Configuration
 * Personalizes the display of updateStatus field with colored badges
 */
export default {
  config: {},

  bootstrap(_app: StrapiApp) {
    setupStatusStyling();
  },
};
